var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-xl px-4 lg:px-4 pt-2 pb-4 lg:pb-4 shadow bg-white ring-orange-500"},[_c('div',{ref:"chart",staticStyle:{"width":"300px","height":"300px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }